import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BRAND, BRAND_RADIUS } from '../../theme/brandTokens';

const StoreCustomerSectionCard = ({ title, icon, action, children }) => (
  <Box
    sx={{
      borderRadius: BRAND_RADIUS.card,
      background: BRAND.surface,
      border: '1px solid',
      borderColor: BRAND.line,
      overflow: 'hidden',
      height: '100%',
    }}
  >
    <Box
      sx={{
        px: 2.5,
        py: 1.5,
        minHeight: 52,
        backgroundColor: BRAND.background,
        borderBottom: '1px solid',
        borderColor: BRAND.line,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
        {icon ? (
          <Box sx={{ color: BRAND.accentText, display: 'flex', alignItems: 'center' }}>
            {icon}
          </Box>
        ) : null}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: BRAND.text,
            lineHeight: 1.35,
          }}
        >
          {title}
        </Typography>
      </Stack>
      {action}
    </Box>
    <Box sx={{ p: { xs: 2, sm: 2.5 } }}>
      {children}
    </Box>
  </Box>
);

export default StoreCustomerSectionCard;
